// @flow
import React, { type Node } from 'react';
import { handleComponentError } from 'Errors/clientErrorHandler';

type Props = {
  children: Node,
  useNativeErrorHandling?: boolean,
};

type State = {
  hasError: boolean,
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error: *, info: *) {
    handleComponentError(error, info);
  }

  render() {
    if (this.state.hasError && !this.props.useNativeErrorHandling) {
      return null;
    }

    return this.props.children;
  }
}
